import createCardListingView from '../Views/createCardListingView';
import FlexExternalProjectCard from './FlexExternalProjectCard';

export default createCardListingView(FlexExternalProjectCard, {
  displayName: 'ExternalProjectListingView',
});
